export default "__VITE_ASSET__CdhsqFw9__"